// context.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class myCreditsMobileService {
  private showCredits = new BehaviorSubject<boolean | null>(false);
  public showCredits$ = this.showCredits.asObservable();

  setOrigen(show: boolean) {
    this.showCredits.next(show);
  }

  clearOrigen() {
    this.showCredits.next(false);
  }
}
